import styled from "styled-components";

export const BodyCardToggle = styled.div`
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.2s ease-out;
  &.is-open {
    grid-template-rows: 1fr;
  }
  .inner {
    overflow: hidden;
  }
`;
